// @flow

import React, { type Node } from 'react';
import { CopyToClipboardIcon, DataList, Term, Definition } from '../../../../commons/molecules';
import { Padding, HighlightBox } from '../../../../commons/atoms';
import { useIncomingPayment, getSafeCipCode } from '@tectonics/prs/incoming-payment';

export function PagoefectivoCipInformation(): Node {
  const incomingPayment = useIncomingPayment();

  if (incomingPayment.status !== 'PE') {
    throw new Error('Cip Code Information: Incoming Payment status should be PE');
  }

  const cipCode = getSafeCipCode(incomingPayment);

  return (
    <HighlightBox>
      <Padding value="1em">
        <DataList>
          <Term>Cod. de Pago CIP</Term>
          <Definition>
            <CopyToClipboardIcon value={cipCode}>{cipCode}</CopyToClipboardIcon>
          </Definition>

          <Term>Empresa recaudadora</Term>
          <Definition>PagoEfectivo</Definition>

          <Term>Servicio</Term>
          <Definition>Sistema de transferencia de pagos (STP)</Definition>

          <Term>Beneficiario</Term>
          <Definition>PagoEfectivo Soles</Definition>
        </DataList>
      </Padding>
    </HighlightBox>
  );
}
